export default {"src":"/_next/static/media/twitter.bc2def9e.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};